


































import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem, SkeletonBox } from '@/layouts/components'

import { ItemGroup } from '@/models'

import ItemImage from './ItemImage.vue'

@Component({
  components: {
    ItemImage,
    ListItem,
    SkeletonBox
  }
})
export default class ItemGroupTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly itemGroup!: ItemGroup

  isLoadingImage = true
}
